import { ChangeDetectorRef, Component, Input, NgZone, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { PlanRegion } from "src/app/generated-models/PlanRegion";
import { ApiService } from "src/app/services";
import { PlanRegionOverallApproval } from "src/app/generated-models/PlanRegionOverallApproval";

@Component({
  standalone: false,
  templateUrl: "./plan-batch-approval.component.html",
  styleUrls: ["../../../../styles.scss"],
})
export class PlanBatchApprovalComponent implements OnInit {
  @Input() title: string;
  @Input() planRegions: PlanRegion[];

  public aggregatedResult: string[] = [];
  public isCompleted = false;

  constructor(
    public activeModal: NgbActiveModal,
    protected apiService: ApiService,
    private ngZone: NgZone,
    private cdr: ChangeDetectorRef,
  ) { }
  async ngOnInit(): Promise<void> {
    await this.batchApprovalPlanRegions();
  }

  close(): void {
    this.activeModal.close(true);
  }

  async batchApprovalPlanRegions() {
    this.isCompleted = false;
    this.aggregatedResult = [];

    await Promise.all(
      this.planRegions.map(async (planRegion) => {
        try {
          const planRegionOverallApproval: PlanRegionOverallApproval = {
            ApprovedVersion: planRegion.Version,
            Blueprint: planRegion.Blueprint,
          } as PlanRegionOverallApproval;

          await this.apiService.approvePlanRegion(planRegion.ServiceTreeId, planRegion.Region, planRegionOverallApproval).toPromise();
          this.appendResult(`Approve plan region <b>${planRegion.ServiceTreeId}</b> successfully`);
        } catch (ex) {
          this.appendResult(`Approve plan region <b>${planRegion.ServiceTreeId}</b> failed with error: ${ex}`);
        }
      })
    );

    this.ngZone.run(() => {
      this.isCompleted = true;
      this.cdr.detectChanges();
    });
  }

  private appendResult(message: string) {
    this.aggregatedResult.push(message);
    this.ngZone.run(() => {
      this.cdr.detectChanges();
    });
  }
}
